module.exports = __webpack_public_path__ + "static/img/P2.6d13b2ed.png";